import {PassedInitialConfig} from 'angular-auth-oidc-client';
import {environment} from '../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    secureRoutes: [
      '/api',
      '/public',
      ...(environment.serverUrl ? [`${environment.serverUrl}/api`, `${environment.serverUrl}/public`] : []),
      environment.portalBaseUrl,
      '/ui',
    ],
    authority: `${environment.oidcIssuerUrl}`,
    redirectUrl: window.location.origin + '/ui/callback',
    postLogoutRedirectUri: window.location.origin + '/ui/logout',
    postLoginRoute: '/admin/dashboard',
    clientId: environment.clientId,
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
    ignoreNonceAfterRefresh: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    startCheckSession: true,
    triggerRefreshWhenIdTokenExpired: true,
    logLevel: environment.ngOidcLogLevel,
    maxIdTokenIatOffsetAllowedInSeconds: 900 //15mn
  }
}
